import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { DataTableConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { PERMISSION } from '../../../analytics-core/interfaces/permission.interface';

@Component({
	selector: 'app-datatable',
	styleUrls: ['./datatable.component.css'],
	templateUrl: './datatable.component.html'
})
export class DataTableComponent implements OnInit, OnChanges, WidgetCore, OnDestroy {
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() key: string;
	@Input() secondarykey: string;
	@Input() datatableconfig;
	@Input() isVerticalScrollable;
	@Input() rowHeight;
	@Input() isTotalCalc;
	@Input() isClickable;
	@Input() hasprerollplacementsaccess: any;
	@Input() nodatamessage;
	@Input() columnsconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() queryorderby: any;
	@Input() downloadcsvorderby: any;
	@Input() toplinks: any;
	@Input() isemail: boolean;
	@Input() iscustomendpoint: any;
	@Input() downloadconfig: any;

	// tslint:disable-next-line: prefer-output-readonly
	@Output() moveToSlide = new EventEmitter<any>();
	@ViewChild(DatatableComponent) table: DatatableComponent;
	public asc = {};
	public isDOOH: boolean = false;

	showLoad = true;
	reorderable = false;
	public tableConfig: DataTableConfig = {} as DataTableConfig;
	public dataTableObj: any = { data: [], columns: [] };
	public cssClasses: any = {
		pagerLeftArrow: 'datatable-icon-left',
		pagerNext: 'datatable-icon-skip',
		pagerPrevious: 'datatable-icon-prev',
		pagerRightArrow: 'datatable-icon-right',
		sortAscending: 'datatable-icon-down',
		sortDescending: 'datatable-icon-up'
	};

	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};

	public footerHeight;
	public reloadSubscription;
	public widgetDataSubscription;
	public hasData = false;
	public columns: any;
	public downloadConfiguration: any;
	public downloadCSVColumns: any;
	public isRadio: boolean;
	public currentPage = 0;
	public downloadIcon: any = null;
	public newTabXLSXRequired: boolean = false;
	public selectedList: any;
	public lineItemTableData: any;
	public showLineItems: boolean;
	public isR8: boolean = false;
	public isR4: boolean = false;
	public isR3: boolean = false;
	public isR6: boolean = false;
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
		this.isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (this.isemail && this.toplinks?.length > 0) {
			this.hasData = true;
			this.showLoad = false;
			this.processResponseData(this.toplinks);
		}
	}

	ngAfterContentChecked(): void {
		// Called after every check of the component's or directive's content.
		// Add 'implements AfterContentChecked' to the class.
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r7') {
			jQuery('.ngx-datatable.datatable .datatable-footer .datatable-pager li:nth-last-child(2)').addClass(
				'primary-color-bg'
			);
			jQuery('.ngx-datatable.datatable .datatable-footer .datatable-pager li:nth-child(2)').addClass(
				'primary-color-bg'
			);
		}
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r6') {
			jQuery('.ngx-datatable.datatable .datatable-footer .datatable-pager li.active').addClass('primary-color-bg');
		}
	}

	ngOnInit(): void {
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		this.isDOOH = this.analyticsDataModel.getCurrentPath() === PATHS.DOOH;
		this.isR4 = this.analyticsDataModel.config.version === 'R4' ? true : false;
		this.isR6 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r6';
		this.isR3 = ['default-r3', 'default-marketron-r3'].includes(
			this.analyticsDataModel.config.directoryName.toLowerCase()
		);
		if (this.isR8) {
			this.tooltipOptions['theme'] = 'light';
		}
		if (this.isR4) {
			this.tooltipOptions['duration'] = 50;
		}
		if (typeof this.datatableconfig === 'string') {
			this.tableConfig = JSON.parse(decodeURI(this.datatableconfig));
		} else {
			this.tableConfig = this.datatableconfig;
		}
		this.tableConfig.columns = _.filter(this.tableConfig.columns, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		if (this.isR3 || this.isR4) {
			this.isVerticalScrollable = this.tableConfig.isVerticalScrollable ?? this.isVerticalScrollable;
		}
		if (!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') {
			this.nodatamessage = 'No data to display';
		}
		this.downloadConfiguration = this.downloadconfig ? JSON.parse(decodeURI(this.downloadconfig)) : undefined;
		this.downloadCSVColumns = this.downloadcsvcolumns
			? Array.isArray(this.downloadcsvcolumns)
				? this.downloadcsvcolumns
				: JSON.parse(decodeURI(this.downloadcsvcolumns))
			: [];
		this.columns =
			this.columnsconfig && typeof this.columnsconfig === 'string'
				? JSON.parse(decodeURI(this.columnsconfig))
				: this.columnsconfig
				? this.columnsconfig
				: [];
		this.queryorderby = this.queryorderby ? JSON.parse(decodeURI(this.queryorderby)) : [];
		this.downloadcsvorderby = this.downloadcsvorderby ? JSON.parse(decodeURI(this.downloadcsvorderby)) : [];
		this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
		this.dataTableObj.limit = this.tableConfig.limit ? this.tableConfig.limit : 10;
		this.footerHeight = this.isVerticalScrollable ? 0 : 50;
		this.rowHeight = this.tableConfig.rowHeight ? this.tableConfig.rowHeight : 'auto';
		this.key =
			this.hasprerollplacementsaccess === 'true'
				? this.analyticsDataModel.setupData.userPermissions['hasPrerollCompletionAccess']
					? this.key
					: this.secondarykey
				: this.key;
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		if (this.tableConfig && this.tableConfig.permission && this.tableConfig?.permission['flags']) {
			this.newTabXLSXRequired = !this.tableConfig.permission['flags']
				.map((permission) => {
					return this.analyticsDataModel
						.checkComponentForPermission({ permission: { flags: [permission] } })
						.toString();
				})
				.includes('false');
		}
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
		this.showLoad = true;
		if (this.toplinks?.length > 0 && this.isemail) {
			this.hasData = true;
			this.showLoad = false;
			this.dataTableObj.data = this.toplinks;
			this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
			this.processResponseData(this.toplinks);
		} else {
			if (this.iscustomendpoint == 'true') {
				this.widgetDataSubscription = this.analyticsService
					.processCustomServiceRequest(this.key)
					.subscribe((res: any) => {
						this.showLoad = false;
						this.dataTableObj.data = [];
						if (res.success && res.data.length > 0) {
							this.hasData = true;
							this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
							this.processResponseData(res.data);
						} else {
							this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {});
							this.hasData = false;
							this.dataTableObj.data = [];
						}
					});
			} else {
				this.widgetDataSubscription = this.analyticsService
					.processWidgetRequest(this.key, this.columns, this.queryorderby)
					.subscribe((res: any) => {
						this.showLoad = false;
						this.dataTableObj.data = [];
						if (res.success && res.data.length > 0) {
							this.hasData = true;
							this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
							this.processResponseData(res.data);
						} else {
							this.hasData = false;
							this.dataTableObj.data = [];
						}
					});
			}
		}
	}

	processResponseData(responseData: any): void {
		this.generateDateTableConfiguration(responseData);
	}

	generateDateTableConfiguration(responseData: any): void {
		this.dataTableObj.data = this.generateResponseDataFromConfig(responseData);
	}

	customSort(headerName: string): void {
		this.table.sorts = [];
		if (!this.asc[headerName]) {
			this.dataTableObj.data = _.sortBy(this.dataTableObj.data, (item) => {
				return moment(item[headerName]);
			});
			this.asc[headerName] = true;
			this.currentPage = 0;
		} else {
			this.dataTableObj.data = _.sortBy(this.dataTableObj.data, (item) => {
				return moment(item[headerName]);
			}).reverse();
			this.asc[headerName] = false;
			this.currentPage = 0;
		}
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.tableConfig.csvQueryKey
				? this.tableConfig.csvQueryKey
				: this.downloadConfiguration.csvQueryKey
				? this.downloadConfiguration.csvQueryKey
				: this.key,
			this.tableConfig.downloadFileName ? this.tableConfig.downloadFileName : this.downloadConfiguration.fileName,
			this.downloadCSVColumns,
			this.downloadcsvorderby,
			this.newTabXLSXRequired ? this.tableConfig.newTabCsvQueryKey : '',
			this.newTabXLSXRequired ? this.tableConfig.newTabCsvFileName : ''
		);
	}

	comparator(propertyName: string, a: any, b: any, c: any, d: any): number {
		if (parseFloat(c[propertyName]) < parseFloat(d[propertyName])) {
			return 1;
		}
		if (parseFloat(c[propertyName]) > parseFloat(d[propertyName])) {
			return -1;
		}
	}

	onUserEvent(event: any): void {
		if (event.type === 'click') {
			if (this.isClickable) {
				this.moveToSlide.emit(event.row);
			}
		}
	}
	onSort(event: any): void {
		this.currentPage = 0;
	}

	onPageChange(event: any): void {
		this.currentPage = event.offset;
	}

	protected generateColumnConfigurationForDataTable(): any[] {
		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		let columnsConfig = UtilityService.checkForVisibilityPermissions(this.tableConfig.columns, dateSet);
		if (this.hasprerollplacementsaccess) {
			if (!this.analyticsDataModel.setupData.userPermissions['hasPrerollCompletionAccess']) {
				columnsConfig = columnsConfig.filter((item) => item.columnKey !== 'completions_percent');
			}
		}
		// check for permission
		const userPermissions: any[] = this.analyticsDataModel.setupData.permissions;
		if (_.indexOf(userPermissions, PERMISSION[PERMISSION.hasOfflineVisits]) == -1) {
			columnsConfig = columnsConfig.filter((item) => item.columnKey !== 'offline_visits');
		}
		const sortedColumnConfig = _.sortBy(columnsConfig, 'columnOrder');
		const columns = [];
		for (const colConfig of sortedColumnConfig) {
			const colObj: any = {} as any;
			colObj.name = colConfig.columnName;
			colObj.prop = colConfig.columnType === 'number' ? 'formatted_' + colConfig.columnKey : colConfig.columnKey;
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.hasProgressBar = colConfig.columnHasProgressBar;
			colObj.showTitle = colConfig.columnShowTitle;
			colObj.columnKey = colConfig.columnKey;
			colObj.columnType = colConfig.columnType;
			if (
				colConfig.columnType === 'number' ||
				(colConfig.columnType === 'string' && colConfig.columnKey === 'lineItem')
			) {
				colObj.comparator = this.comparator.bind(this, colConfig.columnKey);
			}
			colObj.resizeable = false;
			colObj.columnHasTooltip = colConfig.columnHasTooltip;
			colObj.columnTooltip = colConfig.columnTooltip;
			colObj.columnDisplayImage = colConfig.columnDisplayImage;
			columns.push(colObj);
		}
		return columns;
	}

	protected generateResponseDataFromConfig(responseData: any): any[] {
		const processedData = [];
		for (const responseObj of responseData) {
			processedData.push(this.getDerivedResponseObj(responseObj));
		}
		return processedData;
	}

	protected getDerivedResponseObj(responseObj: any): object {
		const columnObj: any = {};
		const columnsConfig = this.tableConfig.columns ? this.tableConfig.columns : [];
		for (const columnConfig of columnsConfig) {
			if (!Array.isArray(columnConfig.columnType)) {
				if (columnConfig.columnKey === 'average_lift' && responseObj[columnConfig.columnKey].replace(/,/g, '') > 99) {
					responseObj[columnConfig.columnKey] = '>99X';
				} else if (columnConfig.columnKey === 'average_lift') {
					responseObj[columnConfig.columnKey] = Number(responseObj[columnConfig.columnKey]) + 'X';
				}
				if (columnConfig.columnType === 'number') {
					const value = parseFloat(responseObj[columnConfig.columnKey]);
					columnObj[columnConfig.columnKey] = responseObj[columnConfig.columnKey] != null ? value : 0;
					if (columnConfig.columnKey === 'Avg. Position') {
						columnObj['formatted_' + columnConfig.columnKey] =
							responseObj[columnConfig.columnKey] != null ? numeral(value).format('0,0.00') : '--';
					} else {
						columnObj['formatted_' + columnConfig.columnKey] =
							responseObj[columnConfig.columnKey] != null
								? this.isFloat(value)
									? numeral(value).format('0,0.00')
									: numeral(value).format('0,0')
								: '--';
					}
					if (columnConfig.columnPrepend.length > 0 && columnObj['formatted_' + columnConfig.columnKey] !== '--') {
						if (parseFloat(columnObj['formatted_' + columnConfig.columnKey]).toFixed(2) === '100.00') {
							// tslint:disable-next-line: binary-expression-operand-order
							columnObj['formatted_' + columnConfig.columnKey] = 100 + columnConfig.columnPrepend;
						} else {
							columnObj['formatted_' + columnConfig.columnKey] =
								parseFloat(columnObj['formatted_' + columnConfig.columnKey]).toFixed(2) + columnConfig.columnPrepend;
						}
					}
				} else if (columnConfig.columnType === 'date') {
					columnObj[columnConfig.columnKey] = moment(responseObj[columnConfig.columnKey]).format(
						columnConfig.columnFormat
					);
				} else {
					if (this.sectionclass === 'o_o_lift_chart_card') {
						if (columnConfig.columnKey === 'average_baseline') {
							columnObj[columnConfig.columnKey] =
								UtilityService.isUndefinedOrNull(responseObj[columnConfig.columnKey]) ||
								Number(responseObj[columnConfig.columnKey]) === 0
									? '< 0.01%'
									: responseObj[columnConfig.columnKey] + '%';
						} else {
							columnObj[columnConfig.columnKey] =
								UtilityService.isUndefinedOrNull(responseObj[columnConfig.columnKey]) ||
								Number(responseObj[columnConfig.columnKey]) === 0
									? '< 0.01'
									: responseObj[columnConfig.columnKey];
						}
					} else {
						if (this.isR6 && columnConfig.columnKey === 'lineItem') {
							columnObj['formatted_' + columnConfig.columnKey] = responseObj[columnConfig.columnKey];
							const value = responseObj[columnConfig.columnKey];
							const lastPipeIndex = value.lastIndexOf('|');
							if (lastPipeIndex !== -1) {
								columnObj[columnConfig.columnKey] = value.slice(lastPipeIndex + 1).trim();
							} else {
								columnObj[columnConfig.columnKey] = value;
							}
						} else {
							columnObj[columnConfig.columnKey] =
								columnConfig.columnKey == 'venue_type'
									? responseObj[columnConfig.columnKey].split('>').join('\u00A0\u00A0>\u00A0\u00A0')
									: responseObj[columnConfig.columnKey];
						}
					}
				}
			} else {
				const columnKeys = columnConfig.columnKey;
				for (const columnKey of columnKeys) {
					columnObj[columnKey] = responseObj[columnKey];
				}
			}
		}
		columnObj['description'] = responseObj['description'];
		columnObj['is_platform'] = responseObj['is_platform'];
		if (responseObj['favicon_url']) {
			columnObj['favicon_url'] = encodeURI(decodeURIComponent(responseObj['favicon_url']));
		}
		if (responseObj['logo_path']) {
			columnObj['logo_path'] = encodeURI(decodeURIComponent(responseObj['logo_path']));
		}
		if (responseObj['browser_logo_path']) {
			columnObj['browser_logo_path'] = encodeURI(decodeURIComponent(responseObj['browser_logo_path']));
		}
		return columnObj;
	}

	protected isFloat(n: any): any {
		return Number(n) === n && n % 1 !== 0;
	}

	protected isInteger(n: any): any {
		return Number(n) === n && n % 1 === 0;
	}
}
